import * as React from 'react';
import styled from 'styled-components';
import { colors } from './colors/color';
import { PageSectionVariant } from './PageSectionDefs';

// -----------------------------------------------------------------
// ---- See notes in PageSectionDefs.ts
// -----------------------------------------------------------------

type PageSectionContentProps = {
    headerStyleVariant: PageSectionVariant;
    contentStyleVariant:PageSectionVariant,
    padding?: string;
    hasHeader?: boolean;
}

export const PageSectionContent = (props:React.PropsWithChildren<PageSectionContentProps>): JSX.Element => 
{
    if(props.contentStyleVariant === 'card')
        return  <CardContent headerStyleVariant={props.headerStyleVariant || 'card'} 
                    padding={props.padding || '16px'}>    
                    {props.children}
                </CardContent>;
    else
        return  <MinimalContent headerStyleVariant={props.headerStyleVariant || 'minimal'} 
                    padding={props.padding || '0'}>
                    {props.children}
                </MinimalContent>;
}

const MinimalContent = styled.div<{headerStyleVariant:PageSectionVariant, padding:string}>`
    background: transparent;
    padding: ${props => props.padding};
`;

const CardContent = styled.div<{headerStyleVariant:PageSectionVariant, padding:string}>`
    background: white;
    border: 1px solid ${colors.section.border.normal};
    border-top:${props => props.headerStyleVariant === 'card' ? '0px' : `1px solid ${colors.section.border.normal}`};
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    border-top-left-radius: ${props => props.headerStyleVariant === 'card' ? '0px' : '6px'};
    border-top-right-radius: ${props => props.headerStyleVariant === 'card' ? '0px' : '6px'};
    padding: ${props => props.padding};
`;